/**
 * Block-for-block skeleton for the chef kitchen pages (/orders/kitchen,
 * /shopping-list, /recipes, /deliverables) while the shipments range
 * loads: page header, the date-stepper toolbar row, and two campus-card
 * placeholders. Per the CLAUDE.md "Loading states" guidance, never
 * render `Loading...` text.
 */

import { Skeleton } from '@ordo/ui/skeleton'

export function KitchenOrdersSkeleton() {
  return (
    <div
      className="mx-auto flex h-full w-full min-h-0 max-w-[100rem] flex-col px-0 lg:px-4"
      aria-busy="true"
      aria-label="Loading orders">
      <div className="px-4 pt-4 lg:px-0 lg:pt-5">
        <div className="flex items-center gap-3">
          <Skeleton className="h-9 w-9 rounded-md" />
          <Skeleton className="h-8 w-28" />
        </div>
      </div>

      <div className="flex items-center justify-between gap-3 px-2 pb-3 pt-4 lg:py-5 lg:pl-0 lg:pr-3">
        <Skeleton className="h-9 w-64 rounded-full" />
        <div className="hidden gap-2 lg:flex">
          <Skeleton className="h-9 w-48 rounded-full" />
          <Skeleton className="h-9 w-32 rounded-full" />
        </div>
      </div>

      <div className="flex flex-col gap-3 px-2 pb-4 lg:px-0">
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className="rounded-2xl border border-border p-4 lg:p-6">
            <div className="mb-4 flex items-center justify-between">
              <div className="space-y-1.5">
                <Skeleton className="h-5 w-56" />
                <Skeleton className="h-3 w-40" />
              </div>
              <Skeleton className="h-8 w-24 rounded-full" />
            </div>
            <div className="space-y-2">
              {Array.from({ length: 3 }).map((_, row) => (
                <div key={row} className="flex items-center justify-between gap-4 rounded-lg border p-3">
                  <Skeleton className="h-4 w-44" />
                  <Skeleton className="h-4 w-16" />
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
